import React from "react";
import {Button} from "primereact/button";
import {Message} from "primereact/message";
import {ProgressSpinner} from "primereact/progressspinner";
import {Tag} from "primereact/tag";
import {Avatar as PrimeAvatar} from "primereact/avatar";

const projectColorClasses = {
    red: "bg-red-100 text-red-700",
    blue: "bg-blue-100 text-blue-700",
    purple: "bg-purple-100 text-purple-700",
    green: "bg-green-100 text-green-700",
    orange: "bg-orange-100 text-orange-700",
};

function getProjectColor(project) {
    const value = project?.color_icon?.color;
    return typeof value === "string" && /^#[0-9a-f]{6}$/i.test(value) ? value : null;
}

export function MobilePageHeader({title, description, onBack, action}) {
    return (
        <div className="flex align-items-center gap-2 mb-3">
            {onBack && <Button type="button" rounded text className="w-3rem h-3rem flex-shrink-0" icon="pi pi-angle-right" onClick={onBack} aria-label={title}/>} 
            <div className="flex-1 min-w-0">
                <h1 className="text-lg text-900 m-0 mb-1 text-overflow-ellipsis overflow-hidden white-space-nowrap">{title}</h1>
                {description && <p className="text-xs text-500 m-0 line-height-3">{description}</p>}
            </div>
            {action}
        </div>
    );
}

export function MobileLoading() {
    return <div className="h-15rem flex align-items-center justify-content-center"><ProgressSpinner className="w-3rem h-3rem" strokeWidth="4"/></div>;
}

export function MobileError({message, retryLabel, onRetry}) {
    return (
        <div className="flex flex-column gap-3 align-items-center p-4 surface-card mobile-brand-radius">
            <Message className="w-full text-xs" severity="error" text={message}/>
            {onRetry && <Button type="button" outlined className="text-xs gap-2" icon="pi pi-refresh" label={retryLabel} onClick={onRetry}/>} 
        </div>
    );
}

export function MobileEmpty({icon = "pi pi-inbox", title, description, action}) {
    return (
        <div className="flex flex-column align-items-center justify-content-center text-center gap-2 min-h-12rem surface-card border-1 border-100 mobile-brand-radius p-4">
            <i className={`${icon} text-3xl text-300`}/>
            <strong className="text-sm text-700">{title}</strong>
            {description && <span className="text-xs text-500 line-height-3">{description}</span>}
            {action}
        </div>
    );
}

export function PriorityTag({priority, translate}) {
    if (!priority) return null;
    const severity = priority === "critical" ? "danger" : priority === "important" ? "warning" : "secondary";
    return <Tag className="text-2xs font-normal" severity={severity} value={translate(`mobile-shell.priority.${priority}`)}/>;
}

export function ProjectIndicator({project, className = "w-2rem h-2rem"}) {
    const namedColor = projectColorClasses[project?.color_icon?.color] || "surface-100 text-primary";
    const backgroundColor = getProjectColor(project);
    return (
        <PrimeAvatar
            icon={project?.color_icon?.icon || "pi pi-folder"}
            shape="circle"
            className={`${className} flex-shrink-0 ${backgroundColor ? "text-white" : namedColor}`}
            pt={backgroundColor ? {root: {style: {backgroundColor}}} : undefined}
            aria-label={project?.title}
        />
    );
}
